<template lang="pug">
include /mixins
+b.t-product-action.BUTTON(
  @click='openModal'
  :title="_('Просмотр 360')"
)
  +e.icon-wrapper
    +e.img.IMG(
      src='/static/img/360-degree-rotate-icon.svg'
      :alt='_("share icon")'
      loading="lazy"
    )
</template>

<script>
import ImageSpinView from '@app/Image360/View'

export default {
  name: 'ImageSpinPreview',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    openModal() {
      this.$modal.show(ImageSpinView, {
        id: this.id,
      }, {
        height: 'auto',
        classes: ['cart-modal'],
        adaptive: true,
        scrollable: true,
        clickToClose: false,
      })
    },
  },
}
</script>
